interface Props {
    functionName: string
    property1: 'btn-function-select' | 'btn-function'
    className?: string
    onClick?: () => void
}

export const BtnFunction = ({
    functionName = '近期概況',
    property1,
    className,
    onClick
}: Props): JSX.Element => {
    return (
        <button
            onClick={onClick}
            className={`inline-flex items-center gap-1.5 md:gap-2.5 px-4 md:px-8 lg:px-[51px] py-2 md:py-3 lg:py-[17px] overflow-hidden rounded-[15px_15px_0px_0px] md:rounded-[20px_20px_0px_0px] justify-center relative transition-colors ${property1 === 'btn-function-select' ? 'left-5' : 'left-[283px]'
                } ${property1 === 'btn-function-select' ? 'bg-white' : 'bg-[#eaeade]'
                } ${className || ''}`}
        >
            <div
                className="[font-family:'Noto_Sans_TC',Helvetica] w-fit tracking-[3.20px] md:tracking-[4.80px] lg:tracking-[6.40px] text-lg md:text-2xl lg:text-[32px] text-[#33363f] font-bold text-center whitespace-nowrap leading-5 md:leading-4 relative"
            >
                {functionName}
            </div>
        </button>
    )
}
